export default __webpack_public_path__ + "static/media/close.9583d637.svg";